/**
 * GroupListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * GroupListReq
 */
export interface GroupListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 群组列表筛选 */
  filter_preset?: string
  /** 群类型 */
  type?: string
  /** 群主ID */
  owner_id?: any
  /** 最小段位 */
  rank_tier__gte?: number
  /** 最大段位 */
  rank_tier__lte?: number
  /** 成员数范围 */
  member_count__range?: string
  /** 最小活跃度 */
  activity_level__gte?: number
  /** 群名称包含 */
  name__like?: string
  /** 群简介包含 */
  bio__like?: string
  /** 类型列表 */
  type__in?: string[]
  /** 群主ID列表 */
  owner_id__in?: any
}

/**
 * GroupListReq Schema
 */
export const GroupListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    filter_preset: {
      description: '群组列表筛选',
      format: 'cons.GroupListFilterPreset',
      type: 'string',
      label: '群组列表筛选',
    },
    type: {
      description: '群类型',
      enum: ['camp,battle'],
      format: 'string',
      type: 'string',
      label: '群类型',
    },
    owner_id: {
      description: '群主ID',
      format: 'string',
      type: 'user',
      label: '群主ID',
    },
    rank_tier__gte: {
      description: '最小段位',
      format: '*int',
      type: 'integer',
      label: '最小段位',
    },
    rank_tier__lte: {
      description: '最大段位',
      format: '*int',
      type: 'integer',
      label: '最大段位',
    },
    member_count__range: {
      description: '成员数范围',
      format: '*string',
      type: 'string',
      label: '成员数范围',
    },
    activity_level__gte: {
      description: '最小活跃度',
      format: '*int',
      type: 'integer',
      label: '最小活跃度',
    },
    name__like: {
      description: '群名称包含',
      format: 'string',
      type: 'string',
      label: '群名称包含',
    },
    bio__like: {
      description: '群简介包含',
      format: 'string',
      type: 'string',
      label: '群简介包含',
    },
    type__in: {
      description: '类型列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '类型列表',
    },
    owner_id__in: {
      description: '群主ID列表',
      format: '[]string',
      type: 'user',
      label: '群主ID列表',
    },
  },
  type: 'object',
}
